import React, { useEffect, useMemo } from 'react'
import PageContainer from '../containers/PageContainer'
import PageTitleCard from '../cards/PageTitleCard'
import PageTitleText from '../texts/PageTitleText'
import { useTranslation } from 'react-i18next'
import TermsAndConditionsText from '../common/TermsAndConditionsText'

type Props = {}

const TermsAndConditionsPage = (props: Props) => {
    const { t } = useTranslation();
    const text = useMemo(() => {
        return t("payment.terms_and_conditions_text");
    }, [t("payment.terms_and_conditions_text")]);

    useEffect(() => {
        document.title = `QuickPick - ${t("navigation.terms_and_conditions")}`;
    }, [t("navigation.terms_and_conditions")]);

    return (
        <div>
            <PageContainer>
                <PageTitleCard>
                    <PageTitleText>
                        {t("navigation.terms_and_conditions")}
                    </PageTitleText>
                </PageTitleCard>
                <TermsAndConditionsText />
            </PageContainer>
        </div>
    )
}

export default TermsAndConditionsPage